import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Typography } from '@material-ui/core'
import AnswerCard from './AnswerCard'
import TableCard from './TableCard'
import StepRow from './StepRow'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20
  },
  sectionLabel: {
    fontSize: 11,
    fontWeight: 'var(--font-weight-bold, 700)',
    textTransform: 'uppercase',
    letterSpacing: 0.8,
    color: 'var(--color-neutral-500, #6b7280)',
    margin: '0 0 -8px'
  },
  tablesGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },
  stepsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  }
}))

export default function ReportView ({ report }) {
  const classes = useStyles()
  if (!report) return null

  const inner = report.report || {}
  const tables = Array.isArray(inner.tables) ? inner.tables : []
  const steps = Array.isArray(inner.steps) ? inner.steps : []

  return (
    <div className={classes.root}>
      <Typography component='div' className={classes.sectionLabel}>Answer</Typography>
      <AnswerCard answer={inner.answer} />

      {tables.length > 0 && (
        <>
          <Typography component='div' className={classes.sectionLabel}>Supporting evidence</Typography>
          <div className={classes.tablesGroup}>
            {tables.map(t => <TableCard key={t.id} table={t} />)}
          </div>
        </>
      )}

      {steps.length > 0 && (
        <>
          <Typography component='div' className={classes.sectionLabel}>How the agent reached this answer ({steps.length} steps)</Typography>
          <div className={classes.stepsList}>
            {steps.map(s => <StepRow key={s.id} step={s} />)}
          </div>
        </>
      )}
    </div>
  )
}

ReportView.propTypes = {
  report: PropTypes.shape({
    report: PropTypes.object
  })
}
